// DietAssessmentScreen.js

import React, { useState, useEffect, memo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import DietAssessment from '../../components/DietAssessment';
import Screen from '../../components/Screen/Screen';

const DietAssessmentScreen = () => {
  const { enableDietAssessment20: isDietAssessmentEnabled } = useFlags();
  const [enabled, setEnabled] = useState(isDietAssessmentEnabled);

  useEffect(() => {
    if (isDietAssessmentEnabled && !enabled) {
      setEnabled(true);
    }
  }, [isDietAssessmentEnabled, enabled]);

  return (
    <Screen
      title="Diet ID"
      showSidebarNav
      isSidebarOpen
    >
      {enabled && <DietAssessment />}
    </Screen>
  );
};

export default memo(DietAssessmentScreen);
